import { useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import isEmpty from 'lodash/isEmpty';
import withStyles from '@material-ui/core/styles/withStyles';
import { connect } from 'react-redux';
import { get, post, put } from 'helpers/apiHelpers';
import { combineStyles } from 'helpers/helpers';
import { fetchAllergens } from 'actions/Allergens';
import { fetchDiet, fetchDiets } from 'actions/Diets';
import {
  fetchIngredients,
  fetchIngredientCategories,
} from 'actions/Ingredients';
import buttonsStyle from 'assets/jss/material-dashboard-pro-react/views/buttonsStyle';
import extendedFormsStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle';
import TableActions from 'components/DataTable/Actions';
import moment from 'moment';
import pick from 'lodash/pick';
// eslint-disable-next-line no-duplicate-imports -- FIXME
import { useState } from 'react';
import { toast } from 'react-toastify';
import { useGetCompanyDefaultLanguage } from 'hooks/redux/Translatable/useTranslatableLanguages';

import FormDietsView from './FormDiets.view';
import {
  dayObject,
  days as daysOfWeek,
} from '../../../BrandConfiguration/consts';
import defaultState from '../../defaultState';

// eslint-disable-next-line radix -- FIXME
const toFloat = value => (value === null ? null : parseInt(value));
const timeFields = ['newOrder', 'paymentDeadline'];

const FormDietsContainer = ({
  match,
  location,
  // eslint-disable-next-line no-shadow -- FIXME
  fetchDiets,
  // eslint-disable-next-line no-shadow -- FIXME
  fetchDiet,
  // eslint-disable-next-line no-shadow -- FIXME
  fetchAllergens,
  // eslint-disable-next-line no-shadow -- FIXME
  fetchIngredientCategories,
  // eslint-disable-next-line no-shadow -- FIXME
  fetchIngredients,
  t,
  classes,
  diets,
  history,
  brandConfig,
  allergens,
  diet,
  loading,
  ingredients,
  ingredientCategories,
  selectedBrandId,
}) => {
  const companyDefaultLanguage = useGetCompanyDefaultLanguage();

  const [isFoodsiEnabled, setIsFoodsiEnabled] = useState(false);

  const [state, setState] = useState({
    ...defaultState,
    isEnabledCustomTimeSlots: false,
    chosenDateAndTime: {
      monday: {
        newOrder: {
          day: { label: t('common.sunday'), value: '2021-09-19' },
          time: '00:00',
        },
        paymentDeadline: {
          day: { label: t('common.sunday'), value: '2021-09-19' },
          time: '00:00',
        },
      },
      tuesday: {
        newOrder: {
          day: { label: t('common.monday'), value: '2021-09-20' },
          time: '00:00',
        },
        paymentDeadline: {
          day: { label: t('common.monday'), value: '2021-09-20' },
          time: '00:00',
        },
      },
      wednesday: {
        newOrder: {
          day: { label: t('common.tuesday'), value: '2021-09-21' },
          time: '00:00',
        },
        paymentDeadline: {
          day: { label: t('common.tuesday'), value: '2021-09-21' },
          time: '00:00',
        },
      },
      thursday: {
        newOrder: {
          day: { label: t('common.wednesday'), value: '2021-09-22' },
          time: '00:00',
        },
        paymentDeadline: {
          day: { label: t('common.wednesday'), value: '2021-09-22' },
          time: '00:00',
        },
      },
      friday: {
        newOrder: {
          day: { label: t('common.thursday'), value: '2021-09-23' },
          time: '00:00',
        },
        paymentDeadline: {
          day: { label: t('common.thursday'), value: '2021-09-23' },
          time: '00:00',
        },
      },
      saturday: {
        newOrder: {
          day: { label: t('common.friday'), value: '2021-09-24' },
          time: '00:00',
        },
        paymentDeadline: {
          day: { label: t('common.friday'), value: '2021-09-24' },
          time: '00:00',
        },
      },
      sunday: {
        newOrder: {
          day: { label: t('common.saturday'), value: '2021-09-25' },
          time: '00:00',
        },
        paymentDeadline: {
          day: { label: t('common.saturday'), value: '2021-09-25' },
          time: '00:00',
        },
      },
    },
  });

  const [categories, setCategories] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);

  const dietId = match?.params.id;
  const isEdit = location?.pathname.includes('edit');

  // eslint-disable-next-line react-hooks/exhaustive-deps, require-await -- FIXME
  useEffect(async () => {
    const fetchData = async () => {
      setState(prev => ({ ...prev, isLoading: true }));

      const dietCategories = await get('/diet-categories');
      setCategories(
        dietCategories['hydra:member'].map(category => ({
          '@id': category['@id'],
          value: category.name,
        }))
      );
      fetchDiets();
      fetchAllergens();
      fetchIngredientCategories();
      if (isEdit) {
        // eslint-disable-next-line no-shadow -- FIXME
        const diet = await fetchDiet(dietId);
        const {
          assumptionOfProtein,
          assumptionOfFats,
          assumptionOfCarbohydrates,
        } = diet;

        const carbohydratesAssumption =
          assumptionOfCarbohydrates.assumption ?? '';
        const carbohydratesMargin = assumptionOfCarbohydrates.margin ?? '';
        const fatsAssumption = assumptionOfFats.assumption ?? '';
        const fatsMargin = assumptionOfFats.margin ?? '';
        const proteinAssumption = assumptionOfProtein.assumption ?? '';
        const proteinMargin = assumptionOfProtein.margin ?? '';
        const newState = {
          name: diet.name,
          workName: diet.workName,
          position: diet.position ?? '',
          code: diet.code,
          internalPosition: diet.internalPosition ?? null,
          description: diet.description,
          checked: diet.active,
          allowStepWithAdditionalMealTypes:
            diet.allowStepWithAdditionalMealTypes,
          color: diet.color,
          bagContainer: diet.bagContainer,
          selectedAllergens: diet.excludedAllergens,
          selectedIngredients: diet.excludedIngredients,
          selectedIngredientCategories: diet.excludedIngredientCategories,
          allowSelectMenuFromDiets: diet.allowSelectMenuFromDiets,
          clientImage: diet.clientImage?.['@id'] || null,
          clientImageUrl: diet.clientImage?.contentUrl || null,
          mainImage: diet.mainImage?.['@id'] || null,
          mainImageUrl: diet.mainImage?.contentUrl || null,
          hideDisabledMenuPlannerOptions: diet.hideDisabledMenuPlannerOptions,
          invoiceOverride: diet.invoiceOverride === true,
          invoiceOverrideName: diet.invoiceOverrideName,
          carbohydratesAssumption,
          carbohydratesMargin,
          fatsAssumption,
          fatsMargin,
          proteinAssumption,
          proteinMargin,
          urlSlug: diet.pageSettings.slug ?? '',
          metaTitle: diet.seo.title ?? '',
          metaDescription: diet.seo.description ?? '',
          dietDescription: diet.pageSettings.content ?? '',
          bannerEnabled: diet.banner ? diet.banner.enabled : false,
          bannerHeader: diet.banner ? diet.banner.heading : '',
          bannerText: diet.banner ? diet.banner.content : '',
          numberOfBags: diet.numberOfBags || 1,
        };

        if (diet.banner) {
          newState.bannerId = diet.banner['@id'];

          if (diet.banner.desktop) {
            newState.infoBannerDesktop = diet.banner.desktop['@id'];
            newState.infoBannerDesktopUrl = diet.banner.desktop?.contentUrl;
          }

          if (diet.banner.mobile) {
            newState.infoBannerMobile = diet.banner.mobile['@id'];
            newState.infoBannerMobileUrl = diet.banner.mobile?.contentUrl;
          }
        }

        setSelectedCategories(
          diet.categories.map(category => ({
            '@id': category['@id'],
            value: category.name,
          }))
        );
        setState(prevState => ({ ...prevState, ...newState }));
        // eslint-disable-next-line no-use-before-define -- FIXME
        convertMinutesToDate(diet, brandConfig);
      }

      setState(prev => ({ ...prev, isLoading: false }));

      get(`brands/${selectedBrandId}/modules`, {
        'module[]': 'Foodsi',
        // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
      }).then(res => {
        setIsFoodsiEnabled(res.configuration.Foodsi.enabled);
      });
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIXME
  }, []);

  // eslint-disable-next-line no-shadow -- FIXME
  const convertMinutesToDate = (dietConfig, brandConfig) => {
    const obj = { ...state.chosenDateAndTime };

    daysOfWeek.forEach(dayOfWeek => {
      setState(prevState => ({
        ...prevState,
        [dayOfWeek]: dayObject(dietConfig[dayOfWeek], timeFields),
      }));

      timeFields.forEach(field => {
        const minutes =
          dietConfig?.[dayOfWeek]?.[field] ||
          brandConfig?.[dayOfWeek]?.[field] ||
          0;

        const data = moment(state.tableHeaderDates[dayOfWeek]).subtract(
          minutes,
          'minutes'
        );

        const date = data.format('YYYY-MM-DD');
        const time = data.format('HH:mm');
        const day = data.locale('en').format('dddd');
        obj[dayOfWeek][field].day = { label: day, value: date };
        obj[dayOfWeek][field].time = time;
      });
    });

    const weekDaysConfig = pick(dietConfig, daysOfWeek);
    const isEnabledCustomTimeSlots = Object.entries(weekDaysConfig).some(
      ([, value]) => value !== null
    );

    setState(prevState => ({
      ...prevState,
      isEnabledCustomTimeSlots,
      chosenDateAndTime: obj,
    }));
  };

  const convertDateToMinutes = () => {
    const daysWithConvertedMinutes = {};

    for (const [dayName, value] of Object.entries(state.tableHeaderDates)) {
      const obj = {};

      for (const [dayField, dayFieldData] of Object.entries(
        state.chosenDateAndTime[dayName]
      )) {
        const dayFieldMinutes = moment(value).diff(
          moment(`${dayFieldData.day.value} ${dayFieldData.time}`),
          'minutes'
        );

        obj[dayField] = dayFieldMinutes;
      }

      daysWithConvertedMinutes[dayName] = { ...state[dayName], ...obj };
    }

    return daysWithConvertedMinutes;
  };

  const getItemValue = item => {
    switch (typeof item) {
      case 'string':
        return item;
      case 'object':
        return item['@ContentTranslation'][companyDefaultLanguage];
      default:
        return '';
    }
  };

  const renderIngredients = stateField =>
    state[stateField].map(item => {
      const label = getItemValue(item.label);
      const value = getItemValue(item.value);
      const name = getItemValue(item.name);

      return {
        name: (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              marginLeft: '10px',
            }}
          >
            {/* eslint-disable-next-line no-use-before-define -- FIXME */}
            <TableActions handleRemove={() => removeMeal(stateField, item)} />
            {label || value || name}
          </div>
        ),
      };
    });

  const selectAllergens = ({ target: { value } }) =>
    setState(prev => ({ ...prev, selectedAllergens: value }));

  const selectIngredientCategories = ({ target: { value } }) =>
    setState(prev => ({ ...prev, selectedIngredientCategories: value }));

  const handleInputChange = (event, value) => {
    const newValue = event.target.value;
    setState(prev => ({
      ...prev,
      [event.target.name]: value || newValue,
    }));
  };

  const fillDefaultsMargins = marginName => {
    if (state[marginName] === '') {
      setState(prev => ({ ...prev, [marginName]: 5 }));
    }
  };

  const handleToggle = key => {
    setState(prev => ({ ...prev, [key]: !state[key] }));
  };

  const handleColorPicker = color => {
    setState(prev => ({ ...prev, color: color.hex }));
  };

  const validateSlug = slug => {
    // eslint-disable-next-line prefer-regex-literals -- FIXME
    const pattern = new RegExp(/^[A-Za-z0-9]+(?:-[A-Za-z0-9]+)*$/);

    return pattern.test(slug);
  };

  const validateForm = () => {
    const isSlugValid = isEmpty(state.urlSlug) || validateSlug(state.urlSlug);
    const isDietType = !isEmpty(selectedCategories);
    if (!state.name || !state.code || !isDietType) {
      toast.error(t('form.fillAllRequiredFields'));
    }

    if (!isSlugValid) {
      toast.error(t('form.dits.slugIsInvalid'));
    }

    return state.name && state.code && isSlugValid && isDietType;
  };

  const getImage = (stateName, data) => {
    setState(prev => ({
      ...prev,
      [stateName]: data?.['@id'] || null,
      [`${stateName}Url`]: data?.contentUrl || null,
    }));
  };

  const removeImage = stateName => {
    setState(prev => ({
      ...prev,
      [stateName]: null,
      [`${stateName}Url`]: null,
    }));
  };

  // eslint-disable-next-line require-await -- FIXME
  const getFilteredIngredients = async e =>
    fetchIngredients({
      pageSize: 30,
      page: 0,
      sorted: [],
      logicalFilters: { _orX: [[{ name: e, workName: e }]] },
    });

  // eslint-disable-next-line consistent-return -- FIXME
  const addMeal = itemToAdd => {
    const isAlreadyAdded = state.selectedIngredients.some(
      ingredient => ingredient['@id'] === itemToAdd['@id']
    );

    if (isAlreadyAdded) {
      return toast.error(t('form.ingredientAdded'));
    }

    const selectedIngredients = [...state.selectedIngredients, itemToAdd];

    setState(prevState => ({
      ...prevState,
      selectedIngredients,
    }));
  };

  const removeMeal = (stateField, itemToRemove) => {
    const filteredElements = state[stateField].filter(
      ingredient => ingredient['@id'] !== itemToRemove['@id']
    );
    setState(prev => ({ ...prev, [stateField]: filteredElements }));
  };

  const handleSubmit = () => {
    if (!validateForm()) {
      return;
    }

    const arrayOfObjectToArrayOfIRI = element => element['@id'];

    const excludedIngredients = state.selectedIngredients.map(
      arrayOfObjectToArrayOfIRI
    );
    const excludedAllergens = state.selectedAllergens.map(
      arrayOfObjectToArrayOfIRI
    );
    const excludedIngredientCategories = state.selectedIngredientCategories.map(
      arrayOfObjectToArrayOfIRI
    );

    const {
      carbohydratesAssumption,
      carbohydratesMargin,
      proteinAssumption,
      proteinMargin,
      fatsAssumption,
      fatsMargin,
      roughageAssumption,
      roughageMargin,
    } = state;

    const assumptionOfFats = {
      assumption: toFloat(fatsAssumption),
      margin: toFloat(fatsMargin),
    };
    const assumptionOfCarbohydrates = {
      assumption: toFloat(carbohydratesAssumption),
      margin: toFloat(carbohydratesMargin),
    };
    const assumptionOfProtein = {
      assumption: toFloat(proteinAssumption),
      margin: toFloat(proteinMargin),
    };

    const assumptionOfRoughage = {
      assumption: toFloat(roughageAssumption),
      margin: toFloat(roughageMargin),
    };
    const days = state.isEnabledCustomTimeSlots
      ? convertDateToMinutes()
      : {
          monday: null,
          tuesday: null,
          wednesday: null,
          thursday: null,
          friday: null,
          saturday: null,
          sunday: null,
        };

    const data = {
      name: state.name,
      workName: state.workName,
      position: parseInt(state.position, 10) || null,
      code: state.code,
      internalPosition:
        state.internalPosition === null
          ? null
          : parseInt(state.internalPosition, 10),
      categories: selectedCategories.map(el => el['@id']),
      description: state.description,
      active: state.checked,
      allowStepWithAdditionalMealTypes: state.allowStepWithAdditionalMealTypes,
      color: state.color,
      excludedIngredients,
      excludedAllergens,
      excludedIngredientCategories,
      clientImage: state.clientImage,
      mainImage: state.mainImage,
      invoiceOverride: state.invoiceOverride ?? false,
      invoiceOverrideName: state.invoiceOverrideName,
      allowSelectMenuFromDiets: state.allowSelectMenuFromDiets,
      hideDisabledMenuPlannerOptions:
        state.hideDisabledMenuPlannerOptions ?? false,
      assumptionOfCarbohydrates,
      assumptionOfProtein,
      assumptionOfFats,
      assumptionOfRoughage,
      bagContainer: state.bagContainer,
      numberOfBags: state.numberOfBags,
      seo: {
        title: state.metaTitle,
        description: state.metaDescription,
      },
      pageSettings: {
        slug: isEmpty(state.urlSlug) ? null : state.urlSlug,
        content: state.dietDescription,
      },
      banner: {
        enabled: state.bannerEnabled,
        heading: state.bannerHeader,
        content: state.bannerText,
        desktop: state.infoBannerDesktop,
        mobile: state.infoBannerMobile,
      },
      ...days,
    };

    if (state.bannerId) {
      data.banner['@id'] = state.bannerId;
    }

    setState(prev => ({ ...prev, isSubmitting: true }));

    const action = isEdit
      ? put(`/diets/${dietId}`, data)
      : post('/diets', data);

    action
      // eslint-disable-next-line promise/prefer-await-to-then, consistent-return -- FIXME
      .then(() => {
        history.push('/admin/diets');
        setState(prev => ({ ...prev, isSubmitting: false }));
        if (!isEdit) {
          return toast.warning(t('notify.advancedDiet'));
        }
      })
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
      .catch(() => {
        setState(prev => ({ ...prev, isSubmitting: false }));
      });
  };

  const handleDiets = (e, selected) =>
    setState(prevState => ({
      ...prevState,
      allowSelectMenuFromDiets: selected.map(el => el['@id']),
    }));

  const getDietOptions = () => {
    if (isEdit) {
      return diets.filter(el => el.id !== dietId);
    }

    return diets;
  };

  const handleChange = event => {
    setState(prevState => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }));
  };

  // eslint-disable-next-line consistent-return -- FIXME
  const setBagContainer = obj => {
    if (obj?.id === state.bagContainer?.id) {
      return setState(prev => ({ ...prev, bagContainer: null }));
    }
    setState(prev => ({ ...prev, bagContainer: obj }));
  };

  const setDietSubpageData = (value, name) => {
    setState(prev => ({ ...prev, [name]: value }));
  };

  const handleDietSubpageInputChange = (value, name) => {
    setState(prevState => ({ ...prevState, [name]: value }));
  };

  const handleDietSubpageBannerInputChange = e => {
    setState(prevState => ({
      ...prevState,
      banner: { ...prevState.banner, [e.target.name]: e.target.value },
    }));
  };

  const handleBannerCheckboxChange = () => {
    setState(prevState => ({
      ...prevState,
      bannerEnabled: !state.bannerEnabled,
    }));
  };

  const props = {
    t,
    classes,
    state,
    setFormDietsState: setState,
    getImage,
    removeImage,
    handleSubmit,
    handleChange,
    setDietSubpageData,
    handleBannerCheckboxChange,
    isEdit,
    dietId,
    renderIngredients,
    selectAllergens,
    selectIngredientCategories,
    handleInputChange,
    fillDefaultsMargins,
    handleToggle,
    handleColorPicker,
    getFilteredIngredients,
    addMeal,
    handleDiets,
    getDietOptions,
    setBagContainer,
    handleDietSubpageInputChange,
    handleDietSubpageBannerInputChange,
    allergens,
    diet,
    loading,
    ingredients,
    ingredientCategories,
    categories,
    selectedCategories,
    setSelectedCategories,
    isFoodsiEnabled,
  };

  return <FormDietsView {...props} />;
};

const combinedStyles = combineStyles(extendedFormsStyle, buttonsStyle);

const mapStateToProps = state => ({
  selectedBrandId: state.Auth.selectedBrand,
  diet: state.Diets.diet,
  diets: state.Diets.diets,
  loading: state.Diets.loading,
  allergens: state.Allergens.allergens,
  ingredients: state.Ingredients.ingredients,
  ingredientCategories: state.Ingredients.ingredientCategories,
  brandConfig: state.Brands.brand,
});

export default withTranslation()(
  connect(mapStateToProps, {
    fetchDiet,
    fetchIngredients,
    fetchIngredientCategories,
    fetchAllergens,
    fetchDiets,
  })(withStyles(combinedStyles)(FormDietsContainer))
);
